import { useState } from 'react';
import { Stack, Text, VStack } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import NameField from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const CountryField = ({ darkMode, values }) => {
    const [isHovered, setIsHovered] = useState(false);

    const countryValue =
        values?.country !== '' ? values.country : '- Not Allocated -';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Stack>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Country
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        The country associated with this number block.
                    </Text>
                </Stack>
                <Stack flex="1" minWidth={0}>
                    <VStack width="100%" alignItems="normal">
                        <NameField
                            name="country"
                            id="country"
                            value={countryValue}
                            isDisabled={true}
                            readOnly={true}
                        />
                    </VStack>
                </Stack>
                {isHovered && (
                    <FieldToolTip
                        label="The country where this number block is allocated"
                        ariaLabel="country-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CountryField;
